import { Graphics, NineSlicePlane, Point, Sprite } from 'pixi.js';

import { RadioButton } from './RadioButton';

export interface ScrollRectOpts
{
    width: number,
    height: number,
    buttons: RadioButton[],
    scrollUpdate: (val: number) => void;
}

const tempP = new Point();

export class ScrollRect
{
    public view: Sprite;
    public width: number;
    public height: number;
    public downY: number;

    protected moveId: number;
    protected isDown: boolean;
    
    private _buttons: RadioButton[];

    private _scrollUpdate: (val: number) => void;

    constructor(o: ScrollRectOpts)
    {
        this.view = new Sprite();
        this.view.interactive = true;

        this.view.anchor.set(0.5);

        const bg = new Graphics();

        this.moveId = 99999999;
        this.isDown = false;
        this.downY = 0;
        this._scrollUpdate = o.scrollUpdate;
        
        this._buttons = o.buttons;

        bg.beginFill(0x0, 0.1);
        bg.drawRect(
            0, 0,
            o.width,
            o.height
        );
        bg.alpha = 0;
        bg.position.set(-o.width / 2, -o.height / 2);
        this.view.addChild(bg);

        this.width = o.width;
        this.height = o.height;
        
        this._buttons.forEach(element => {
            element.view.on('mousedown', this.down, this);
            element.view.on('mouseup', this.up, this);
            element.view.on('mouseupoutside', this.up, this);

            element.view.on('touchstart', this.down, this);
            element.view.on('touchend', this.up, this);
            element.view.on('touchendoutside', this.up, this);
            element.view.on('touchcancel', this.up, this);
        });
        
        this.view.on('mousedown', this.down, this);
        this.view.on('mouseup', this.up, this);
        this.view.on('mouseupoutside', this.up, this);

        this.view.on('touchstart', this.down, this);
        this.view.on('touchend', this.up, this);
        this.view.on('touchendoutside', this.up, this);
        this.view.on('touchcancel', this.up, this);

    }

    protected down(e: any): void
    {
        this.moveId = e.data.identifier;

        this.isDown = true;
        const pos = e.data.getLocalPosition(this.view, tempP);
        
        this.downY = pos.y;

        this.view.on('mousemove', this.move, this);
        this.view.on('touchmove', this.move, this);
    }

    protected up(e: any): void
    {
        if (this.moveId !== e.data.identifier) return;

        this.moveId = 99999999;

        this.isDown = false;

        this.view.off('mousemove', this.move, this);
        this.view.off('touchmove', this.move, this);
    }

    protected move(e: any): void
    {
        if (this.moveId !== e.data.identifier) return;
        const pos = e.data.getLocalPosition(this.view, tempP);

        // for some reason on samsung s6 devices getLocal position can return NaN
        // not sure why, but we should check!
        if (isNaN(pos.x) || isNaN(pos.x))
        {
            pos.x = 0;
            pos.y = 0;
        }
        
        var moveY = pos.y - this.downY;
        this.downY = pos.y;

        this._scrollUpdate(moveY);
    }
}
